import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { Calendar } from 'primeng/calendar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rentals-availability-date-picker',
  templateUrl: './rentals-availability-date-picker.component.html',
  styleUrls: ['./rentals-availability-date-picker.component.scss'],
})
export class RentalsAvailabilityDatePickerComponent implements OnInit {
  @Input() rentalConfig: any = {};
  @Input() reservation: any = {};
  @Input() countryData: any = {};
  @Output() dateUpdated = new EventEmitter();
  @Output() clearDateSelected = new EventEmitter();

  public partner: any = {};
  public minDate = new Date();
  public loadingProducts: boolean = false;
  public rentalProducts: any = [];
  public availableSlots: any = [];
  public availableReturnSlots: any = [];
  public showRentalOptionDetail: boolean = false;
  public loadingAvailability: boolean = false;
  public selectedRentalOption: any = {};
  public disabledDates: any = [];
  public disabledReturnDates: any = [];
  public availableDates: any = [];
  public availableReturnDates: any = [];
  public minReturnDate: Date = new Date();
  public maxReturnDate: Date = new Date();
  public rentalDaysMessage: string = '';

  @ViewChild('calendar')
  private calendar!: Calendar;
  @ViewChild('calendarReturn')
  private calendarReturn!: Calendar;

  constructor(
    public rentalsService: RentalsService,
    public helperService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.partner = this.helperService.getPartnerData();

    console.log(this.reservation);

    if (
      this.reservation &&
      this.reservation.fromDate &&
      this.reservation.selectedSlot
    ) {
      this.reservation.reservationDate = new Date(this.reservation.fromDate);
      this.availableSlots = this.reservation.availableSlots;
      //this.dateSelected(this.reservation.reservationDate);
    }

    if (
      this.reservation &&
      this.reservation.toDate &&
      this.reservation.selectedReturnSlot
    ) {
      this.reservation.reservationReturnDate = new Date(
        this.reservation.toDate,
      );
      this.availableReturnSlots = this.reservation.availableReturnSlots;
      this.slotReturnSelected(
        { value: this.reservation.selectedReturnSlot },
        false,
      );
      setTimeout(() => {
        this.getMinReturnDate();
        this.getMaxReturnDate();
        this.getReturnAvailability();
      }, 150);
    }

    if (
      this.reservation &&
      this.reservation.toDate &&
      this.reservation.reservationReturnDate &&
      !this.reservation.selectedReturnSlot
    ) {
      this.reservation.reservationReturnDate = new Date(
        this.reservation.reservationReturnDate,
      );
      setTimeout(() => {
        this.getMinReturnDate();
        this.getMaxReturnDate();
        this.getReturnAvailability();
      }, 150);
    }

    if (
      this.rentalConfig.allowFixedRentalOptions ||
      this.rentalConfig.allowFlexibleRentalOptions
    ) {
      setTimeout(() => {
        this.getAvailability(true);
      }, 100);
    }
  }

  // getProducts() {
  //   if (!this.reservation.selectedDuration || !this.reservation.selectedDuration.timeUnitID) {
  //     this.loadingProducts = true;
  //     this.rentalsService.getStoreProducts(this.partner.externalKey, null, null).subscribe(products => {
  //       this.rentalProducts = products;
  //       this.loadingProducts = false;

  //     }, err => {
  //       this.loadingProducts = false;
  //     });
  //   }
  // }

  monthChanged(event: any) {
    this.getAvailability();
  }

  returnMonthChanged(event: any) {
    this.getReturnAvailability();
  }

  getAvailability(initialLoad: boolean = false) {
    this.loadingAvailability = true;
    var fromDate = moment(
      new Date(this.calendar.currentYear, this.calendar.currentMonth, 1),
    )
      .startOf('month')
      .format('YYYY-MM-DD');
    var toDate = moment(fromDate)
      .endOf('month')
      .add(1, 'day')
      .format('YYYY-MM-DD');
    this.setTempDisabledDates(new Date(fromDate), new Date(toDate));

    if (this.rentalConfig.allowFixedRentalOptions) {
      this.rentalsService
        .getRentalAvailability(this.partner.ID, fromDate, toDate)
        .subscribe(
          (dates) => {
            console.log(dates)
            this.disabledDates = dates.unavailableDates
              ? dates.unavailableDates.map((x: any) => {
                  return moment(x.date).toDate();
                })
              : [];
            this.availableDates = dates.availableDates;
            this.loadingAvailability = false;

            if (
              initialLoad &&
              this.reservation.fromDate &&
              !this.reservation.reservationDate
            ) {
              var selectedDate = this.availableDates
                .filter((x) => {
                  return (
                    moment(this.reservation.fromDate).format(
                      'YYYY-MM-DDT00:00:00',
                    ) == x.date
                  );
                })
                .pop();
              if (selectedDate) {
                this.reservation.reservationDate = moment(
                  moment(this.reservation.fromDate).format('YYYY-MM-DD'),
                ).toDate();
                this.dateSelected(this.reservation.reservationDate);
                if (this.availableSlots) {
                  var slot = this.availableSlots
                    .filter((x) => {
                      return (
                        x.value ===
                        moment(this.reservation.fromDate).format('HH:mm:ss')
                      );
                    })
                    .pop();
                  if (slot) {
                    this.slotSelected({ value: slot }, true);
                  }
                }
              }
            }
          },
          (err) => {
            this.loadingAvailability = false;
          },
        );
    } else if (this.rentalConfig.allowFlexibleRentalOptions) {
      this.rentalsService
        .getRentalFlexibleAvailability(this.partner.ID, fromDate, toDate)
        .subscribe(
          (dates) => {
            this.disabledDates = dates.unavailableDates
              ? dates.unavailableDates.map((x: any) => {
                  return moment(x.date).toDate();
                })
              : [];
            this.availableDates = dates.availableDates;
            this.loadingAvailability = false;
          },
          (err) => {
            this.loadingAvailability = false;
          },
        );
    }
  }

  getReturnAvailability(initialLoad: boolean = false) {
    this.loadingAvailability = true;
    var fromDate = moment(
      new Date(
        this.calendarReturn.currentYear,
        this.calendarReturn.currentMonth,
        1,
      ),
    )
      .startOf('month')
      .format('YYYY-MM-DD');
    var minDate =
      moment(this.reservation.reservationDate).format('YYYY-MM-DD') +
      'T' +
      this.reservation.selectedSlot.value;
    var toDate = moment(fromDate)
      .endOf('month')
      .add(1, 'day')
      .format('YYYY-MM-DD');
    this.setTempDisabledReturnDates(new Date(fromDate), new Date(toDate));

    this.rentalsService
      .getRentalFlexibleReturnDates(this.partner.ID, fromDate, toDate)
      .subscribe(
        (dates) => {
          this.disabledReturnDates = dates.unavailableDates
            ? dates.unavailableDates.map((x: any) => {
                return moment(x.date).toDate();
              })
            : [];
          this.availableReturnDates = dates.availableDates;
          this.loadingAvailability = false;

          if (
            initialLoad &&
            this.reservation.toDate &&
            !this.reservation.reservationReturnDate
          ) {
            this.reservation.reservationReturnDate = moment(
              moment(this.reservation.toDate).format('YYYY-MM-DD'),
            ).toDate();
            this.returnDateSelected(this.reservation.reservationReturnDate);
            if (
              this.rentalConfig.allowFixedRentalOptions &&
              this.reservation.selectedSlot &&
              this.reservation.selectedSlot.durations
            ) {
              var hours = moment(this.reservation.toDate).diff(
                this.reservation.fromDate,
                'hour',
              );
              var duration = this.reservation.selectedSlot.durations
                .filter((x) => {
                  return x.unitType == 'Hour' && x.unit == hours;
                })
                .pop();
              if (duration) {
                this.durationSelected({ value: duration });
              }
            }
            if (
              this.rentalConfig.allowFlexibleRentalOptions &&
              !this.reservation.selectedDuration &&
              this.reservation.availableReturnSlots
            ) {
              var slot = this.reservation.availableReturnSlots
                .filter((x) => {
                  return (
                    x.value ===
                    moment(this.reservation.toDate).format('HH:mm:ss')
                  );
                })
                .pop();
              this.slotReturnSelected({ value: slot });
            }
          }
        },
        (err) => {
          this.loadingAvailability = false;
        },
      );
  }

  setTempDisabledDates(fromDate: Date, toDate: Date) {
    this.disabledDates = [];
    var i = 0;
    for (var d = fromDate; d <= toDate; d = moment(d).add(1, 'day').toDate()) {
      this.disabledDates.push(d);
    }
  }

  setTempDisabledReturnDates(fromDate: Date, toDate: Date) {
    this.disabledReturnDates = [];
    var i = 0;
    for (var d = fromDate; d <= toDate; d = moment(d).add(1, 'day').toDate()) {
      this.disabledReturnDates.push(d);
    }
  }

  isValid() {
    return (
      this.reservation &&
      this.reservation.reservationDate &&
      this.reservation.selectedSlot &&
      this.reservation.selectedDuration &&
      this.reservation.cart &&
      this.reservation.cart.length > 0
    );
  }

  getSizes(summary: any) {
    console.log(summary.brand + summary.model);
    console.log(
      summary.rentalProducts
        .map((x: any) => {
          return x.size;
        })
        .filter(this.onlyUnique),
    );
    return summary.rentalProducts
      .map((x: any) => {
        return x.size;
      })
      .filter(this.onlyUnique);
  }

  onlyUnique(value: any, index: number, self: any) {
    return self.indexOf(value) === index;
  }

  dateSelected(event: any) {
    var selectedDate = this.availableDates
      .filter((x: any) => {
        return (
          moment(x.date).format('YYYY-MM-DD') ===
          moment(event).format('YYYY-MM-DD')
        );
      })
      .pop();
    this.availableSlots = selectedDate.availableSlots.map((x: any) => {
      return { ...x, label: moment('1970-01-01T' + x.value).format('h:mma') };
    });

    this.reservation.selectedSlot = null;
    this.reservation.selectedDuration = null;
    this.reservation.availableSlots = this.availableSlots;
    this.reservation.reservationReturnDate = null;
    this.reservation.selectedReturnSlot = null;
    this.reservation.useFlexibleTimes = false;
    this.reservation.rentalDays = 0;

    this.clearDateSelected.emit();
  }

  returnDateSelected(event: any) {
    var selectedDate = this.availableReturnDates
      .filter((x: any) => {
        return (
          moment(x.date).format('YYYY-MM-DD') ===
          moment(event).format('YYYY-MM-DD')
        );
      })
      .pop();
    this.availableReturnSlots = selectedDate.availableSlots.map((x: any) => {
      return { ...x, label: moment('1970-01-01T' + x.value).format('h:mma') };
    });

    this.reservation.availableReturnSlots = this.availableReturnSlots;
    this.reservation.selectedReturnSlot = null;
    this.reservation.selectedDuration = null;
    this.reservation.useFlexibleTimes = false;
    this.reservation.rentalDays = 0;

    this.clearDateSelected.emit();
  }

  slotSelected(slot: any, initialLoad: boolean = false) {
    this.reservation.selectedSlot = slot.value;
    if (
      this.reservation.selectedSlot &&
      this.reservation.selectedSlot.durations
    ) {
      this.reservation.selectedSlot.durations =
        this.reservation.selectedSlot.durations.map((x) => {
          return {
            ...x,
            label: x.customLabel
              ? x.customLabel
              : x.unit + ' ' + x.unitType + (x.unit !== 1 ? 's' : ''),
          };
        });
    }

    this.reservation.selectedDuration = null;

    if (this.rentalConfig.allowFlexibleRentalOptions) {
      this.availableReturnSlots = [];
      this.reservation.reservationReturnDate = null;
      this.reservation.selectedReturnSlot = null;
      this.reservation.useFlexibleTimes = false;
      this.reservation.rentalDays = 0;
      this.getMinReturnDate();
      this.getMaxReturnDate();
      this.getReturnAvailability(initialLoad);
    }
    this.clearDateSelected.emit();
  }

  slotReturnSelected(slot: any, resetCart: boolean = false) {
    this.reservation.selectedReturnSlot = slot.value;
    this.reservation.selectedDuration = null;
    this.reservation.unitType = null;

    var fromDate =
      moment(this.reservation.reservationDate).format('YYYY-MM-DD') +
      'T' +
      this.reservation.selectedSlot.value;
    var toDate =
      moment(this.reservation.reservationReturnDate).format('YYYY-MM-DD') +
      'T' +
      this.reservation.selectedReturnSlot.value;
    var timeUnitID = 0;

    this.reservation.fromDate = moment(fromDate).toDate();
    this.reservation.toDate = moment(toDate).toDate();

    if (resetCart) {
      this.reservation.cart = [];
    }

    var hours = moment(toDate).diff(fromDate, 'hours');
    var days = Math.round(moment(toDate).diff(fromDate, 'days', true));

    if (this.rentalConfig.flexibleReservationConfiguration.addExtraDay) {
      days += 1;
    }
    if (days == 0) {
      days += 1;
    }

    if (hours / 24.0 > days) {
      this.rentalDaysMessage = 'OVER';
      this.reservation.rentalDays = days + 1;
    } else if (hours / 24.0 < days) {
      this.rentalDaysMessage = 'UNDER';
      this.reservation.rentalDays = days;
    } else {
      this.rentalDaysMessage = 'EXACT';
      this.reservation.rentalDays = days;
    }

    this.reservation.useFlexibleTimes = true;
    this.dateUpdated.emit({ fromDate, toDate, timeUnitID });
  }

  durationSelected(event: any, resetCart: boolean = false) {
    var duration = event.value;
    if (duration) {
      this.reservation.selectedDuration = duration;
      this.reservation.selectedReturnSlot = null;
      var fromDate =
        moment(this.reservation.reservationDate).format('YYYY-MM-DD') +
        'T' +
        this.reservation.selectedSlot.value;
      var toDate = moment(
        moment(this.reservation.reservationDate).format('YYYY-MM-DD') +
          'T' +
          this.reservation.selectedSlot.value,
      )
        .add(
          this.reservation.selectedDuration.unit,
          this.reservation.selectedDuration.unitType,
        )
        .format('YYYY-MM-DDTHH:mm:ss');
      var timeUnitID = this.reservation.selectedDuration.timeUnitID;

      this.reservation.fromDate = moment(fromDate).toDate();
      this.reservation.toDate = moment(toDate).toDate();

      this.reservation.unitType = duration.unitType;
      this.reservation.useFlexibleTimes = false;
      this.dateUpdated.emit({ fromDate, toDate, timeUnitID });
    }
  }

  refreshDates() {
    this.getAvailability();
  }

  isSameDayBooking() {
    return (
      moment(this.reservation.reservationDate).format('YYYY-MM-DD') ===
      moment(this.reservation.reservationReturnDate).format('YYYY-MM-DD')
    );
  }

  getMinReturnDate() {
    if (this.rentalConfig.allowFixedRentalOptions) {
      this.minReturnDate = this.reservation.reservationDate;
    } else {
      this.minReturnDate = moment(this.reservation.reservationDate)
        .add(
          this.rentalConfig.flexibleReservationConfiguration
            .minimumDurationValue,
          this.rentalConfig.flexibleReservationConfiguration
            .mimimumDurationUnitType == 1
            ? 'hours'
            : this.rentalConfig.flexibleReservationConfiguration
                  .mimimumDurationUnitType == 2
              ? 'days'
              : 'days',
        )
        .toDate();
    }
  }

  getMaxReturnDate() {
    this.maxReturnDate = moment(this.reservation.reservationDate)
      .add(
        this.rentalConfig.flexibleReservationConfiguration.maximumDurationValue,
        this.rentalConfig.flexibleReservationConfiguration
          .maximumDurationUnitType == 1
          ? 'hours'
          : this.rentalConfig.flexibleReservationConfiguration
                .maximumDurationUnitType == 2
            ? 'days'
            : 'days',
      )
      .toDate();
  }
}
